/*
 * Copyright (c) 2022 E-WIND - Thais Watanabe.
 * All rights reserved.
 */
import React from "react";

import isInputCorrect from "src/utils/ResultValidationHelper";

import Card from "src/components/cards/Card.react";
import ResultDropdown from "src/components/dropdowns/Result.react";

import {
  Table,
  ColHeader,
  TableBody,
  Col,
} from "src/components/tables/Table.react";
import ResultBadge from "src/components/badges/Result.react";

/**
 * The TransformerRoom component
 *
 * @author Thais Watanabe
 */
const TransformerRoom = (props) => {
  const {
    inspection,
    turbineInspection,
    lastTurbineInspections,
    inspectionModelItems,
    results,
    lastResults,
    openEdit,
    openObs,
  } = props;

  const i12_4 = inspectionModelItems.filter((obj) => obj.name === "12-4")?.[0];
  const r12_4 = results.filter((obj) => obj.itemId === "12-4")?.[0];

  const lastOneYear = lastTurbineInspections.find((obj) =>
    obj.inspection.type.startsWith("1年")
  );

  const lastInspection = lastResults?.filter(
    (obj) => obj.itemId === "12-4" && obj.turbineInspectionID === lastOneYear
  )?.[0];

  return (
    <Card title="ラジエータ冷却ファン 絶縁測定結果表" className="print:mt-2">
      <Table>
        <thead>
          <tr>
            <ColHeader id="12-4" className="w-28 text-center print:hidden" rowSpan={2}>
              <ResultDropdown
                turbineInspection={turbineInspection}
                openEdit={openEdit}
                openObs={openObs}
                selectedItem={i12_4}
                selectedResult={r12_4}
                lastTurbineInspections={lastTurbineInspections}
                inspection={inspection}
              />
            </ColHeader>
            <ColHeader className="text-center" colSpan={2}>
              今回
            </ColHeader>
            <ColHeader className="text-center">
              {lastOneYear?.inspection?.name ?? "過去"}
            </ColHeader>
          </tr>
          <tr>
            <ColHeader className="text-center">No</ColHeader>
            <ColHeader className="text-center">絶縁抵抗(MΩ)</ColHeader>
            <ColHeader className="text-center">絶縁抵抗(MΩ)</ColHeader>
          </tr>
        </thead>
        <TableBody>
          <tr>
            <Col className="text-center print:hidden"></Col>
            <Col className="text-center">1</Col>
            <Col className="text-center">
              <ResultBadge
                result={r12_4?.childrenResults[1] ?? "-"}
                unit={i12_4?.inspectionModelItemChildren.items?.[1].unit}
                isInputCorrect={isInputCorrect(
                  i12_4?.name,
                  r12_4?.childrenResults[1] ?? "-",
                  1
                )}
              />
            </Col>
            <Col className="text-center">
              <ResultBadge
                result={lastInspection?.childrenResults[1] ?? "-"}
                unit={i12_4?.inspectionModelItemChildren.items?.[1].unit}
                isInputCorrect={isInputCorrect(
                  i12_4?.name,
                  lastInspection?.childrenResults[1] ?? "-",
                  1
                )}
              />
            </Col>
          </tr>
        </TableBody>
      </Table>
    </Card>
  );
};

export default TransformerRoom;
